import { Box, Divider, Flex, Heading, Text } from '@podiumhq/design-system';
import { useExperiment } from '@podiumhq/tracking';

import PodiumLogoIcon from 'components/PodiumLogo/PodiumLogoIcon';
import { getBundlePrices } from 'components/PricingPackaging/utils';
import { useSelectPlanCheckoutContext } from 'contexts/SelectPlanCheckoutContextProvider';
import { BUY_NOW_WITH_DISCOUNT } from 'lib/amplitude/flags.constants';

import { YEARLY_TERM } from '../../PricingPackaging/constants';

import SelectedPlanSummaryDiscountContent from './SelectedPlanSummaryDiscountContent';

const SelectedPlanSummary = ({ term = 'month', ...boxProps }) => {
  const [fetchingExperiment, showDiscountPricing] = useExperiment(
    BUY_NOW_WITH_DISCOUNT
  );
  const {
    orgPrices,
    selectedPlan = {},
    selectedTerm,
  } = useSelectPlanCheckoutContext() || {};

  const {
    displayName: planName,
    monthlyPrice,
    annualPrice,
  } = selectedPlan || {};

  const isAnnual = selectedTerm === YEARLY_TERM;
  const discountPrice = getBundlePrices({
    allPrices: orgPrices,
    bundlePlan: selectedPlan.plan,
    term: selectedTerm,
  });

  const price = isAnnual ? annualPrice : monthlyPrice;

  return (
    <Box
      backgroundColor="silver.light"
      borderRadius="12px"
      boxSizing="border-box"
      padding="24px"
      width="100%"
      {...boxProps}
    >
      <Flex>
        <PodiumLogoIcon height="48px" mr="16px" width="48px" />

        <Box>
          <Flex align="center" justify="space-between">
            <Heading color="black.base" mb="4px" {...boldTextStyles}>
              {planName}
            </Heading>

            <Text {...lightTextStyles}>${price}</Text>
          </Flex>

          <Text mt="3px" {...lightTextStyles}>
            {isAnnual
              ? '12 month agreement. Billed monthly.'
              : 'Billed on a month-to-month basis'}
          </Text>
        </Box>
      </Flex>

      <Divider mt="24px" mb="20px" color="grey.lightest" />

      <SelectedPlanSummaryDiscountContent
        discountPrice={
          !fetchingExperiment && showDiscountPricing === 'on' && discountPrice
        }
      />

      <Flex justify="space-between" paddingBottom="4px">
        <Text {...boldTextStyles}>Total</Text>
        <Text {...boldTextStyles}>${price}</Text>
      </Flex>
      <Flex justify="right">
        <Text {...lightTextStyles}>USD/mo. + taxes</Text>
      </Flex>
      {isAnnual ? (
        <Flex justify="right">
          <Text {...lightTextStyles}>with 12 month agreeement</Text>
        </Flex>
      ) : (
        <></>
      )}
    </Box>
  );
};

const boldTextStyles = {
  fontSize: 'lg',
  fontWeight: 'medium',
};

const lightTextStyles = {
  fontSize: 'md',
  fontWeight: 'normal',
  color: 'black.lighter',
};

export default SelectedPlanSummary;
